import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DescriptionIcon from "@mui/icons-material/Description";
import TagIcon from "@mui/icons-material/Tag";
import InfoRow from "../common/InfoRow";
import StatusChip from "../common/StatusChip";
import { formatCurrency } from "../../utils/currencyUtils";
import { AccountResponseDto } from "../../shared/dtos/account/AccountResponseDto";

interface AccountCardProps {
  account: AccountResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const AccountCard: React.FC<AccountCardProps> = ({
  account,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }} noWrap>
              {account.name}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
              <StatusChip status={account.type} />
              {!account.active && <StatusChip status="INACTIVE" />}
            </Stack>
          </Box>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={2} sx={{ flexGrow: 1 }}>
          <Stack direction="row" spacing={2}>
            <InfoRow
              icon={<TagIcon fontSize="small" />}
              label="Code"
              value={account.accountCode}
            />
            <InfoRow
              icon={<AccountBalanceWalletIcon fontSize="small" />}
              label="Balance"
              value={formatCurrency(account.balance)}
            />
          </Stack>
          {account.description && (
            <InfoRow
              icon={<DescriptionIcon fontSize="small" />}
              label="Description"
              value={account.description}
            />
          )}
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default AccountCard;
